<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="11" offset-lg="1">
        <h2 class="title mb-5">システム通知一覧</h2>
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center" style="width: 100px">カテゴリー</th>
                <th class="text-left">タイトル</th>
                <th class="text-center" style="max-width: 150px">通知日時</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="information in systemInformations"
                :key="information.id"
                @click="openDetailDialog(information)"
              >
                <td class="text-center">
                  <v-chip
                    :color="translateCategoryJa(information.category).color"
                    label
                    outlined
                    x-small
                  >
                    {{ translateCategoryJa(information.category).label }}
                  </v-chip>
                </td>
                <td>{{ information.title }}</td>
                <td class="text-center">
                  {{ information.notificationStartAt | momentDateTime }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>

    <SystemInformationDetailDialog
      :dialog="dialog"
      :information="information"
      @close-dialog="dialog = false"
    >
    </SystemInformationDetailDialog>
  </v-container>
</template>

<script>
import { deserialize } from 'deserialize-json-api'
import SystemInformationDetailDialog from '/src/container/shared/SystemInformationDetailDialogs'
import formatUtils from '@/mixins/format_utils'
import api from '@/plugins/api'
import systemInformationUtils from '@/mixins/system_information_utils'

export default {
  name: 'SystemInformations',
  mixins: [formatUtils, systemInformationUtils],
  components: {
    SystemInformationDetailDialog
  },
  data () {
    return {
      systemInformations: [],
      information: {},
      dialog: false
    }
  },
  async mounted () {
    try {
      let { data } = await api.fetchSystemInformations()
      this.systemInformations = deserialize(data).data
    } catch (error) {
      const payload = {
        status: error.response.status,
        message: error.response.data.errors.toString()
      }
      this.$store.dispatch('SystemMessageStore/createMessage', payload)
    }
  },
  methods: {
    openDetailDialog (information) {
      this.information = information
      this.dialog = true
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
